<script setup lang="ts">
  defineProps<{
    code: string,
  }>()
</script>

<template>
  <span class="bg-gray-100 px-2 py-1 rounded text-xs inline-block">
    {{ code }}
  </span>
</template>
